import { ApiBase, ApiResponse } from '../api-base';
import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { TeamSettingEntity } from './team-setting-entity';

@inject(IHttpClient)
export class TeamApi extends ApiBase {

    constructor(http: IHttpClient) {
        super(http);
    }

    // ── Group-scoped (primary) ────────────────────────────────────────────────

    public async getByGroupId(eventId: string, groupId: string): Promise<TeamSettingEntity[]> {
        const response = await this.get(this._groupUrl(eventId, groupId));
        return TeamSettingEntity.fromDtoArray(response.content);
    }

    public async addToGroup(eventId: string, groupId: string, entity: TeamSettingEntity): Promise<TeamSettingEntity> {
        const response = await this.post(this._groupUrl(eventId, groupId), entity.toDto());
        return TeamSettingEntity.fromDto(response.content);
    }

    public async updateInGroup(eventId: string, groupId: string, id: string, entity: TeamSettingEntity): Promise<TeamSettingEntity> {
        const response = await this.patch(`${this._groupUrl(eventId, groupId)}/${id}`, entity.toDto());
        return TeamSettingEntity.fromDto(response.content);
    }

    public async deleteFromGroup(eventId: string, groupId: string, id: string): Promise<ApiResponse> {
        return await this.delete(`${this._groupUrl(eventId, groupId)}/${id}`);
    }

    public async deleteAllByGroupId(eventId: string, groupId: string): Promise<ApiResponse> {
        return await this.delete(this._groupUrl(eventId, groupId));
    }

    // ── Schedule-scoped (backward compat — read-only, used by scheduler runner) ──

    public async getByScheduleId(scheduleId: string): Promise<TeamSettingEntity[]> {
        const response = await this.get(this._scheduleUrl(scheduleId));
        return TeamSettingEntity.fromDtoArray(response.content);
    }

    // ── Helpers ───────────────────────────────────────────────────────────────

    private _groupUrl(eventId: string, groupId: string): string {
        return `api/events/${eventId}/groups/${groupId}/teamsettings`;
    }

    private _scheduleUrl(scheduleId: string): string {
        return `api/schedules/${scheduleId}/teamsettings`;
    }
}
